<template>
  <div class="display-section-label"><slot></slot></div>
</template>

<style scoped>
.display-section-label {
  padding: 18px 0 8px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);
}
</style>
